import { openBlock as t, createElementBlock as e, createElementVNode as l } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 41 40"
}, n = /* @__PURE__ */ l("path", {
  fill: "#FFDA44",
  d: "M34.142 34.142c-7.81 7.81-20.474 7.81-28.284 0-7.81-7.81-7.81-20.474 0-28.284.003 0 17.973-5.31 25.784 2.5 7.81 7.81 2.506 25.779 2.5 25.784Z"
}, null, -1), c = /* @__PURE__ */ l("path", {
  fill: "#D80027",
  d: "M34.284 34.142c7.81-7.81 7.81-20.474 0-28.284-7.81-7.81-20.473-7.81-28.284 0l28.284 28.284Z"
}, null, -1), s = /* @__PURE__ */ l("path", {
  fill: "#FF9811",
  d: "M25.228 25.23a3.039 3.039 0 0 1-2.605-.177 3.047 3.047 0 0 1-1.164-4.143l-.25-.14a5.661 5.661 0 0 0 4.328-5.562 5.639 5.639 0 0 0-1.932-4.183l-1.826 1.87a3.038 3.038 0 0 1 1.15 2.344 3.047 3.047 0 0 1-3.007 3.08l.003.286a5.661 5.661 0 0 0-6.98-.966 5.64 5.64 0 0 0-2.656 3.765l2.533.646a3.039 3.039 0 0 1 1.455-2.167 3.047 3.047 0 0 1 4.17 1.063l.246-.146a5.66 5.66 0 0 0 2.654 6.528 5.639 5.639 0 0 0 4.588.419l-.707-2.517Z"
}, null, -1), a = /* @__PURE__ */ l("path", {
  fill: "#FFEACF",
  d: "m27.405 13.545-1.414 5.045-4.24-.783-2.731-5.628-7.376 2.617-.581-1.639-1.93-.238 1.454 4.098 5.076-1.298 1.442 4.065-3.509 5.178 5.955 5.079-1.129 1.323.76 1.79 2.82-3.308-3.661-3.747 2.799-3.281 6.239.45 1.42-7.697 1.711.316 1.171-1.552-4.276-.79Z"
}, null, -1), d = [
  n,
  c,
  s,
  a
];
function i(_, h) {
  return t(), e("svg", o, [...d]);
}
const f = { render: i };
export {
  f as default,
  i as render
};
